export default __webpack_public_path__ + "static/logo-signature-portal-67810e8681a2d3d21632735f23d99338.png";